<template>
  <div class="px-4 lg:px-32 mt-[18rem] lg:mt-[20rem] mb-[110px]">
    <FilterCaseStudies @filters-updated="handleFiltersUpdated"/>
    <div class="flex flex-col gap-y-[132px] mt-[114px]">
      <CaseStudyCard
        v-for="(study, index) in filteredCaseStudies"
        :key="study.id"
        :study="study"
        :index="index"
        :orientation="index % 2 === 0 ? 'left' : 'right'"
        :active-filters="selectedFilters"
      />
    </div>
  </div>
  <GetInTouch :homepage="false"/>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';
import FilterCaseStudies from "../components/CaseStudiesComponents/FilterCaseStudies.vue";
import GetInTouch from "../components/GetInTouch.vue";
import CaseStudyCard from "../components/CaseStudiesComponents/CaseStudyCard.vue";
import { useRouter } from "vue-router";
import img_44 from '../assets/caseStudies/img_44.png';
import img_45 from '../assets/caseStudies/img_45.png';
import img_22 from '../assets/caseStudies/img_22.png';
import img_25 from '../assets/caseStudies/img_25.png';
import img_26 from '../assets/caseStudies/img_26.png';
import img_28 from '../assets/caseStudies/img_28.png';
import img_29 from '../assets/caseStudies/img_29.png';
import img_30 from '../assets/caseStudies/img_30.png';
import img_31 from '../assets/caseStudies/img_31.png';
import img_34 from '../assets/caseStudies/img_34.png';
import img_35 from '../assets/caseStudies/img_35.png';
import img_36 from '../assets/caseStudies/img_36.png';
import img_38 from '../assets/caseStudies/img_38.png';
import img_39 from '../assets/caseStudies/img_39.png';
import img_42 from '../assets/caseStudies/img_42.png';
import img_46 from '../assets/caseStudies/img_46.png';
import img_49 from '../assets/caseStudies/img_49.png';
import img_50 from '../assets/caseStudies/img_50.png';
import img_52 from '../assets/caseStudies/img_52.png';
import img_56 from '../assets/caseStudies/img_56.png';
import img_57 from '../assets/caseStudies/img_57.png';
import img_58 from '../assets/caseStudies/img_58.png';
import img_59 from '../assets/caseStudies/img_59.png';
import img_1 from '../assets/caseStudies/img_1.png';
import img_5 from '../assets/caseStudies/img_5.png';
import img_20 from '../assets/caseStudies/img_20.png';
import svg_item1 from '../assets/caseStudies/svg-item1.svg';
import svg_item4 from '../assets/caseStudies/svg-item4.svg';
import svg_item5 from '../assets/caseStudies/svg-item5.svg';
import svg_item8 from '../assets/caseStudies/svg-item8.svg';
import svg_item9 from '../assets/caseStudies/svg-item9.svg';
import svg_item10 from '../assets/caseStudies/svg-item10.svg';
import svg_item11 from '../assets/caseStudies/svg-item11.svg';
import svg_item12 from '../assets/caseStudies/svg-item12.svg';
import svg_item13 from '../assets/caseStudies/svg-item13.svg';
import svg_item14 from '../assets/caseStudies/svg-item14.svg';
import svg_item15 from '../assets/caseStudies/svg-item15.svg';
import svg_item16 from '../assets/caseStudies/svg-item16.svg';
import svg_item18 from '../assets/caseStudies/svg-item18.svg';
import svg_item20 from '../assets/caseStudies/svg-item20.svg';
import svg_item21 from '../assets/caseStudies/svg-item21.svg';
import svg_item22 from '../assets/caseStudies/svg-item22.svg';
import svg_item23 from '../assets/caseStudies/svg-item23.svg';
import svg_item25 from '../assets/caseStudies/svg-item25.svg';
import svg_item26 from '../assets/caseStudies/svg-item26.svg';
import svg_item27 from '../assets/caseStudies/svg-item27.svg';
const router = useRouter();
const selectedFilters = ref<string[]>([]);
const caseStudies = [
  {
    id: 'wild',
    slug: 'wild',
    description: 'Post-acquisition, Wild needed to supercharge their creative output - we helped them scale with UGC, static and deep performance learnings.',
    image: img_44,
    brandImage: {
      src: img_45,
      classes: 'absolute left-0 top-0',
    },
    topics: ["Static Ads", "Creator Content Ads", "Data"],
    svgs: [
      { src: svg_item22, classes: 'hidden 2xl:block absolute right-0 translate-x-1/2 2xl:translate-y-1/2 bottom-[10%]', width: '343px', height: '343px' },
      { src: svg_item22, classes: 'hidden lg:block 2xl:hidden absolute right-0 translate-x-1/2 xl:translate-y-1/2 -bottom-[10%] xl:bottom-0 w-2/3' },
      { src: svg_item22, classes: 'lg:hidden absolute right-0 -bottom-[10%]', width: '150px' },
    ],
  },
  {
    id: 'numan',
    slug: 'numan',
    description: 'Tripled ROAS and doubled spend through full-funnel creative, performance strategy, and relentless testing.',
    image: img_22,
    brandImage: {
      src: '', // Numan does not have a brand image on the list
      classes: 'absolute right-0 top-0',
    },
    topics: ["Static Ads", "Motion Ads", "Creator Content Ads"],
    svgs: [
      { src: svg_item5, classes: 'hidden 2xl:block lg:w-full absolute -left-[10%] translate-y-1/2 bottom-0', width: '343px', height: '343px' },
      { src: svg_item5, classes: 'hidden lg:block 2xl:hidden absolute left-0 -translate-x-1/2 translate-y-1/2 bottom-[10%] xl:bottom-0 w-2/3' },
      { src: svg_item10, classes: 'lg:hidden absolute left-0 -top-[15%] z-[99]' },
      { src: svg_item11, classes: 'lg:hidden absolute left-0 -bottom-[5%]' },
      { src: svg_item4, classes: 'hidden lg:block 2xl:hidden absolute -left-0 -translate-x-1/2 top-0 w-2/3' },
      { src: svg_item4, classes: 'hidden 2xl:block absolute -left-0 -translate-x-1/2 top-0' },
    ],
  },
  {
    id: 'katkin',
    slug: 'katkin',
    description: 'We helped KatKin scale spend by 250% while maintaining CPA, through performance-led UGC and creative  data systems.',
    image: img_26,
    brandImage: {
      src: img_25,
      classes: 'absolute left-0 top-0',
    },
    topics: ["Creator Content Ads", "Data", "Performance Marketing"],
    svgs: [
      { src: svg_item15, classes: 'hidden 2xl:block absolute left-0 translate-y-1/2 bottom-[10%]', width: '343px', height: '343px' },
      { src: svg_item15, classes: 'hidden lg:block 2xl:hidden absolute left-0 translate-y-1/2 bottom-[10%] w-2/3' },
      { src: svg_item12, classes: 'lg:hidden absolute right-0 -bottom-[10%]' },
      { src: svg_item13, classes: 'lg:hidden absolute -right-[5%] -top-[2%]' },
      { src: svg_item14, classes: 'hidden lg:block 2xl:hidden absolute -right-[10%] translate-x-1/2 top-0 w-2/3' },
      { src: svg_item14, classes: 'hidden 2xl:block absolute -right-[10%] translate-x-1/2 top-0' },
    ],
  },
  {
    id: 'hbme',
    slug: 'hbme',
    description: 'A heritage wellness brand meets new-age performance marketing through UGC storytelling and best-in-class Meta ad management.',
    image: img_28,
    brandImage: {
      src: img_29,
      classes: 'absolute right-0 top-0',
    },
    topics: ["Static Ads", "Motion Ads", "Creator Content Ads", "Google Ads", "Data", "Performance Marketing", "Pay Per Click", "Organic Social", "Conversion Rate Optimisation", "Landing Pages"],
    svgs: [
      { src: svg_item16, classes: 'lg:hidden absolute left-0 -top-[15%] z-[99]', width: '190px', style: 'backdrop-filter: blur(26.689130783081055px);' },
      { src: svg_item16, classes: 'hidden lg:block 2xl:hidden absolute -left-0 -translate-x-1/2 translate-y-1/2 top-0 w-2/3', style: 'backdrop-filter: blur(26.689130783081055px);border-radius: 8px' },
      { src: svg_item16, classes: 'hidden 2xl:block absolute -left-0 -translate-x-1/2 translate-y-1/2 top-0', style: 'backdrop-filter: blur(26.689130783081055px);border-radius: 8px' },
    ],
  },
  {
    id: 'runna',
    slug: 'runna',
    description: 'Runna came to us for full-service creative support and we delivered across UGC, design, production, and insight-driven iteration.',
    image: img_30,
    brandImage: {
      src: img_31,
      classes: 'absolute left-0 top-0',
    },
    topics: ["Static Ads", "Creator Content Ads","Data"],
    svgs: [
      { src: svg_item23, classes: 'hidden 2xl:block absolute -right-[15%] bottom-10', width: '236px', height: '236px' },
      { src: svg_item23, classes: 'hidden lg:block 2xl:hidden absolute -right-[20%] bottom-10 w-1/3', width: '236px', height: '236px' },
      { src: svg_item23, classes: 'lg:hidden absolute right-[10%] -top-[2%]', width: '100px' },
    ],
  },
  {
    id: 'ebuyer',
    slug: 'ebuyer',
    description: 'For eBuyer, we combined high-velocity UGC testing with performance-led media buying to generate real results from day one.',
    image: img_46,
    brandImage: {
      src: img_36,
      classes: 'absolute right-0 top-0',
    },
    topics: ["Static Ads", "Motion Ads", "Creator Content Ads", "Google Ads", "Data", "Performance Marketing", "Pay Per Click", "Organic Social", "Conversion Rate Optimisation", "Landing Pages"],
    svgs: [
      { src: svg_item18, classes: 'hidden 2xl:block lg:w-full absolute -left-[40%] bottom-0', width: '343px', height: '343px' },
      { src: svg_item18, classes: 'hidden lg:block 2xl:hidden absolute -left-[40%] bottom-0 w-2/3' },
      { src: svg_item18, classes: 'lg:hidden absolute left-0 -top-[15%] z-[99]', width: '180px' },
    ],
  },
  {
    id: 'yonder',
    slug: 'yonder',
    description: 'Yonder trusted us to elevate their creative with premium design and a smart iterative testing framework that uncovered what really moved the needle.',
    image: img_34,
    brandImage: {
      src: img_35,
      classes: 'absolute left-0 top-0',
    },
    topics: ["Static Ads", "Motion Ads", "Creator Content Ads","Data", "Landing Pages"],
    svgs: [],
  },
  {
    id: 'heights',
    slug: 'heights',
    description: 'Creative diversity at speed: how we helped Heights scale Meta spend without compromising on performance.',
    image: img_58,
    brandImage: {
      src: img_59,
      classes: 'absolute right-0 top-0',
    },
    topics: ["Static Ads", "Creator Content Ads",  "Data"],
    svgs: [],
  },
  {
    id: 'frive',
    slug: 'frive',
    description: 'Frive needed end-to-end creative and data support - we gave them a full-service engine that launched fast, tested smart, and scaled successfully.',
    image: img_39,
    brandImage: {
      src: img_38,
      classes: 'absolute left-0 top-0',
    },
    topics: ["Static Ads", "Motion Ads", "Creator Content Ads","Data"],
    svgs: [
      { src: svg_item20, classes: 'hidden 2xl:block absolute right-0 translate-x-1/2 -bottom-[15%]', width: '243px', height: '419px' },
      { src: svg_item20, classes: 'hidden lg:block 2xl:hidden absolute right-0 translate-x-1/2 -bottom-[25%] xl:-bottom-[25%] w-2/3', width: '193px', height: '319px' },
      { src: svg_item20, classes: 'lg:hidden absolute right-[15%] -bottom-[15%]', width: '100px' },
      { src: svg_item25, classes: 'lg:hidden absolute right-0 top-0', width: '130px', height: '130px' },
      { src: svg_item25, classes: 'hidden lg:block 2xl:hidden absolute -right-[10%] translate-x-1/2 top-0 w-2/3' },
      { src: svg_item25, classes: 'hidden 2xl:block absolute -right-[10%] translate-x-1/2 top-0' },
    ],
  },
  {
    id: 'skinMe',
    slug: 'skinMe',
    description: 'Skincare that sells: we helped Skin + Me scale with UGC that performed and creative learnings that kept improving over time.',
    image: img_49,
    brandImage: {
      src: img_50,
      classes: 'absolute right-0 top-0',
    },
    topics: ["Static Ads", "Data", "Creator Content Ads"],
    svgs: [
      { src: svg_item26, classes: 'hidden 2xl:block lg:w-full absolute -left-[30%] top-0', width: '343px', height: '343px' },
      { src: svg_item26, classes: 'hidden lg:block 2xl:hidden absolute -left-[40%] top-0 w-2/3' },
      { src: svg_item26, classes: 'lg:hidden absolute left-10 -top-[15%] z-[99]', width: '130px' },
    ],
  },
  {
    id: 'carmoola',
    slug: 'carmoola',
    description: 'From finance to full-funnel growth: we helped Carmoola scale with strong creative, sharp insights, and test-ready content at speed.',
    image: img_57,
    brandImage: {
      src: img_42,
      classes: 'absolute left-0 top-0',
    },
    topics: ["Static Ads", "Motion Ads", "Creator Content Ads","Data"],
    svgs: [
      { src: svg_item21, classes: 'hidden 2xl:block absolute -right-[20%] top-0', width: '343px', height: '343px' },
      { src: svg_item21, classes: 'hidden lg:block 2xl:hidden absolute -right-[20%] translate-y-1/2 top-0 w-2/3' },
      { src: svg_item21, classes: 'lg:hidden absolute right-[10%] -top-[2%]', width: '100px' },
    ],
  },
  {
    id: 'riseFall',
    slug: 'riseFall',
    description: 'We scaled Rise & Fall revenue 40% and increased NC-ROAS by 22%.',
    image: img_56,
    brandImage: {
      src: img_52,
      classes: 'absolute right-0 top-0',
    },
    topics: ["Creator Content Ads", "Google Ads", "Data", "Pay Per Click", "Performance Marketing"],
    svgs: [
      { src: svg_item27, classes: 'lg:hidden absolute left-0 -bottom-[5%]', width: '120px', height: '120px' },
      { src: svg_item27, classes: 'hidden lg:block 2xl:hidden absolute -left-0 -translate-x-1/2 top-10 w-2/3', width: '225px', height: '225px' },
      { src: svg_item27, classes: 'hidden 2xl:block absolute -left-0 -translate-x-1/2 top-10', width: '225px', height: '225px' },
    ],
  },
  {
    id: 'zoe',
    slug: 'zoe',
    description: 'We scaled ZOE spend by 153% whilst decreasing CPA by 50% in just three months.',
    image: img_20,
    brandImage: {
      src: img_1,
      classes: 'absolute left-0 top-0',
    },
    topics: ["Creator Content Ads", "Google Ads", "Data", "Pay Per Click", "Performance Marketing"],
    svgs: [
      { src: img_5, classes: 'hidden 2xl:block absolute right-0 translate-x-1/2 2xl:translate-y-1/2 bottom-0', width: '343px', height: '343px' },
      { src: img_5, classes: 'hidden lg:block 2xl:hidden absolute right-0 translate-x-1/2 xl:translate-y-1/2 -bottom-[10%] xl:bottom-0 w-2/3' },
      { src: svg_item9, classes: 'lg:hidden absolute right-0 -bottom-[10%]' },
      { src: svg_item1, classes: 'lg:hidden absolute right-0 top-0', width: '136px', height: '136px' },
      { src: svg_item8, classes: 'hidden lg:block 2xl:hidden absolute -right-[10%] translate-x-1/2 top-0 w-2/3' },
      { src: svg_item8, classes: 'hidden 2xl:block absolute -right-[10%] translate-x-1/2 top-0' },
    ],
  },
].map((study, index) => ({
  ...study,
  initialIndex: index,
}));
const handleFiltersUpdated = (filters: string[]) => {
  selectedFilters.value = filters;
};
const filteredCaseStudies = computed(() => {
  if (selectedFilters.value.length === 0) {
    return caseStudies;
  }
  return caseStudies.filter(study =>
      study.topics.some(topic => selectedFilters.value.includes(topic))
  );
});
const goToDetails = (slug: string) => {
  router.push(`/case-studies/${slug}`);
}
</script>

<style lang="scss" scoped></style>
